<template>


  <div id="dlnkmarket_add_product">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="close_message()"
    ></dlnkalert>

    <main id="content" role="main" class="bg-secondary pb-11">

      <h2 class="text-light text-center pt-3">Marketplace</h2>

      <div class="container">

        <div class="d-none d-md-block">

          <!-- Step -->
          <ul class="step step-centered step-md">

            <li class="step-item">
              <a href="#">
                <div class="step-content-wrapper">
                  <span class="step-icon"
                        v-bind:class="step === 'type' ? 'step-icon-primary' : 'step-icon-light' ">1
                  </span>
                  <div class="step-content">
                    <h4 class="text-white">Type de vente</h4>
                  </div>
                </div>
              </a>
            </li>

            <li class="step-item">
              <a href="#">
                <div class="step-content-wrapper">
                  <span class="step-icon"
                        v-bind:class="step === 'description' ? 'step-icon-primary' : 'step-icon-light' ">2</span>
                  <div class="step-content">
                    <h4 class="text-white">Détail de l'annonce</h4>
                  </div>
                </div>
              </a>
            </li>

            <li class="step-item">
              <a href="#">
                <div class="step-content-wrapper">
                  <span class="step-icon"
                        v-bind:class="step === 'validation' ? 'step-icon-primary' : 'step-icon-light' ">3 </span>
                  <div class="step-content">
                    <h4 class="text-white">Validation</h4>
                  </div>
                </div>
              </a>
            </li>

          </ul>

        </div>

        <div class="card shadow-soft p-4 mt-4">

          <div v-if="step==='type'" class="card-body pt-0">

            <div class="row">

              <div class="col-md-6 col-sm-12 ">
                <div
                    class="custom-control custom-radio custom-control-inline checkbox-outline checkbox-icon text-center w-100 ">
                  <input type="radio" id="add_product_donation" name="add_product_donation"
                         class="custom-control-input checkbox-outline-input checkbox-icon-input"
                         @click="go_step_2('don')">
                  <label class="checkbox-outline-label checkbox-icon-label w-100 rounded py-3 px-1 mb-0"
                         for="add_product_donation">
                    <img class="mb-3"
                         src="/modules/dlnkmarket/img/don1.png" alt="Don ">
                    <span class="d-block">Don</span>
                  </label>
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div
                    class="custom-control custom-radio custom-control-inline checkbox-outline checkbox-icon text-center w-100 h-100">
                  <input type="radio" id="add_product_sale" name="add_product_sale"
                         class="custom-control-input checkbox-outline-input checkbox-icon-input"
                         @click="go_step_2('vente')"
                         checked>
                  <label class="checkbox-outline-label checkbox-icon-label w-100 rounded py-3 px-1 mb-0"
                         for="add_product_sale">
                    <img class="  mb-3" src="/modules/dlnkmarket/img/zebricopng/ice-cream.png"
                         alt="SVG">
                    <span class="d-block">Vente</span>
                  </label>
                </div>
              </div>

            </div>
          </div>

          <div v-else-if="step==='description'" class="card-body pt-0">

            <div class="row">

              <div class="mb-2 col-lg-6 col-xs-12 form-group">
                <label>Nom du produit :</label>
                <input type="text" placeholder="Nom du produit" class="form-control"
                       :class="{'is-invalid': product_name_invalid}"
                       v-model="product_name">
                <div class="text-danger" v-if="product_name_invalid">
                  Veuillez renseignez le nom du produit
                </div>
              </div>


              <div class="mb-2 col-lg-6 col-xs-12">
                <label>Code à barres :</label>
                <input type="text" placeholder="Gen Code" class="form-control"
                       :class="{'is-invalid': product_code_invalid}"
                       v-model="product_code">
                <div class="text-danger" v-if="product_code_invalid">
                  Veuillez renseignez le code à barres du produit
                </div>
              </div>
              <!-- Categories -->
              <div class="mb-3 col-12">
                <label>Catégorie</label>

                <select class="custom-select" v-model="product_category_id">
                  <option value="0">-- Selectionnez une catégorie --</option>
                  <option
                      :value="category.id"
                      v-for="category in product_categories"
                      :key="category.id">
                    {{ category.name }}
                  </option>
                </select>
                <div class="text-danger" v-if="product_category_invalid">
                  Veuillez renseignez la catégorie du produit
                </div>
              </div>

              <!-- Form Group -->
              <div class="mb-2 col-12">
                <label for="product_description" class="col-sm-3 col-form-label input-label mt-4">Description</label>

                <ckeditor :editor="editor" v-model="product_description"
                          :class="{'is-invalid': product_description_invalid}"
                          :config="editor_config" id="product_description" name="product_description" >

                </ckeditor>

                <div class="text-danger" v-if="product_description_invalid">
                  Veuillez renseignez la description du produit
                </div>


              </div>
              <!-- End Form Group -->


              <figure class="col-md-6 align-content-stretch mb-5 mb-md-0"
                      data-toggle="tooltip" data-placement="top"
                      title="Photo du produit">
                <img class="img-fluid max-w-33rem w-md-100 h-auto d-block mx-auto border border-light border-3"
                     id="member_photo"
                     :src="product_img"
                     alt="Votre avatar"/>
                <figcaption class="small bg-light text-center max-w-33rem w-md-100 mx-auto p-1">
                  Ajouter / modifier la photo
                  <a href="javascript:;" id="changePictureBtn" class="stretched-link" data-toggle="modal"
                     data-target="#changePictureModal">
                    <i class="fa fa-question-circle"></i>
                  </a>
                </figcaption>
              </figure>


              <dlnk-clipper
                  @imgURL="set_img($event)"
                  :crop_ratio="1.160">
              </dlnk-clipper>

              <div class="col-lg-4 col-xs-12" v-if="type == 'vente'">
                <label>Votre prix</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text">€</span>
                  </div>
                  <input type="number" v-model="product_price" class="form-control" step=".1">
                </div>

                <div class="text-danger" v-if="product_price_invalid">
                  Veuillez renseignez le prix du produit
                </div>

              </div>


            </div>

            <div class="mt-2">

              <a href="#" class="btn btn-sm btn-block btn-primary float-left"
                 @click="go_step_1()"
                 style="width: 150px;">
                Précedent
              </a>


              <a href="#" class="btn btn-sm btn-block btn-primary float-right"
                 @click="go_step_3()"
                 style="width: 150px;">
                Suivant
              </a>

            </div>

          </div>

          <div v-else-if="step==='validation'" class="card-body pt-0">

            <div class="mb-4">
              <h2 class="h3">Récapitulatif</h2>
            </div>

            <div class="row">

              <div class="col-md-6 mb-3 mb-sm-6">
                <div>
                  <label>Nom du produit :</label>
                  <br>
                  <span>{{product_name}}</span>
                </div>
              </div>

              <div class="col-md-6 mb-3 mb-sm-6">
                <div>
                  <label>Code à barres du produit :</label>
                  <br>
                  <span>{{product_code}}</span>
                </div>
              </div>


              <div class="col-md-6 mb-3 mb-sm-6">
                <div>
                  <label>Catégorie du produit</label>
                  <br>
                  <span>{{category_name()}}</span>
                </div>
              </div>


              <div class="col-12 mb-3">
                <div>
                  <label>Description de l'annonce :</label>
                  <br>
                  <span v-html="product_description"></span>
                </div>
              </div>

              <figure class="col-md-2 align-content-stretch mb-5 mb-md-0"
                      data-toggle="tooltip" data-placement="top"
                      title="Photo du produit">
                <img class="img-fluid max-w-33rem w-md-100 h-auto d-block mx-auto border border-light border-3"
                     :src="product_img"
                     alt="Photo du produit"/>
              </figure>


            </div>

            <div class="mt-2">

              <a href="#" class="btn btn-sm btn-block btn-primary float-left"
                 @click="go_step_2(type)"
                 style="width: 150px;">
                Modifier
              </a>


              <a href="#" class="btn btn-sm btn-block btn-primary float-right"
                 @click="validate()"
                 style="width: 150px;">
                Valider
              </a>

            </div>

          </div>

        </div>
      </div>
      <!-- End Form -->

    </main>
  </div>

</template>

<script>

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {

  data: function () {
    return {
      message_type: "",
      message: "",
      step: String,
      type: String,
      product_categories: Array,

      product_category_id: Number,
      product_name: String,
      product_code: String,
      product_description: String,
      product_img: String,
      product_price: Number,

      product_name_invalid: Boolean,
      product_category_invalid: Boolean,
      product_code_invalid: Boolean,
      product_description_invalid: Boolean,
      product_price_invalid: Boolean,


      editor: ClassicEditor,
      editor_config: {
        toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', 'undo', 'redo'],
        heading: {
          options: [
            {model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph'},
            {model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1'},
            {model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2'},
            {model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3'}
          ]
        }
      }
    }
  },

  mounted() {
    this.init()
  },

  methods: {

    set_img: function (img_url) {
      this.product_img = img_url
    },

    init: function () {
      this.step = 'type'
      this.product_name = ""
      this.product_code = ""
      this.product_category_id = 0
      this.product_description = ""
      this.product_price = 0
      this.product_name_invalid = false
      this.product_category_invalid = false
      this.product_code_invalid = false
      this.product_description_invalid = false
      this.product_price_invalid = false
      this.product_img = "/themes/template/img/default-image-gradient-380x380.png"
      this.get_data()
    },

    close_message: function () {
      this.message = null
      this.get_data()
    },

    go_step_1: function () {
      this.step = 'type'
    },

    go_step_2: function (type) {
      this.step = 'description'
      this.type = type
    },

    product_correct: function () {
      const _this = this
      let ready = true

      if (_this.product_name.length > 127 || _this.product_name < 3) {
        _this.product_name_invalid = true
      } else {
        _this.product_name_invalid = false
      }

      if (_this.product_code.length > 64 ) {
        _this.product_code_invalid = true
      } else {
        _this.product_code_invalid = false
      }

      if (_this.product_description.length < 5) {
        _this.product_description_invalid = true
      } else {
        _this.product_description_invalid = false
      }

      if (_this.product_category_id === 0) {
        _this.product_category_invalid = true
      } else {
        _this.product_category_invalid = false
      }

      if (_this.product_price < 0.1 && _this.type == 'vente') {
        _this.product_price_invalid = true
      } else {
        _this.product_price_invalid = false
      }

      ready = !(_this.product_name_invalid || _this.product_code_invalid || _this.product_description_invalid || _this.product_category_invalid || _this.product_price_invalid)

      return ready
    },

    go_step_3: function () {
      if (this.product_correct()) {
        this.step = 'validation'
      }
    },

    post_product: function () {
      // "pictures_attributes"=>{"1637518311241"=>{"legend"=>"", "file"=>#<ActionDispatch::Http::UploadedFile:0x000000013e9a5e68 @tempfile=#<Tempfile:/var/folders/s1/629xmj6148j_lg5pck36t7080000gn/T/RackMultipart20211121-22874-ojs49n.jpg>, @original_filename="img19.jpg", @content_type="image/jpeg", @headers="Content-Disposition: form-data; name=\"product[pictures_attributes][1637518311241][file]\"; filename=\"img19.jpg\"\r\nContent-Type: image/jpeg\r\n">, "is_default"=>"0", "_destroy"=>"false"}}
    },

    category_name: function () {
      const _this = this
      const index = _this.product_categories.findIndex(c => c.id == _this.product_category_id);
      return _this.product_categories[index].name
    },

    get_data: async function () {

      const _this = this;
      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += "/product_categories.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id


      axios.get(api_url)
          .then(function (response) {
            _this.product_categories = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    validate: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += "/products.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      const form_data = new FormData();
      form_data.append('product[name]',                 _this.product_name)
      form_data.append('product[code]',                 _this.product_code)
      form_data.append('product[description]',          _this.product_description)
      form_data.append('product[product_category_id]',  _this.product_category_id)
      form_data.append('product[price]',                _this.product_price)
      form_data.append('base64',                       _this.product_img)

      // user.avatar = {data: base64}

      axios({
        method: 'post',
        url: api_url,
        data: form_data,
        headers: {'Content-Type': 'multipart/form-data'}
      })
          .then(function (response) {
            //handle success
            const status = response.data.status;

            if (status) {
              _this.message = "Votre produit à été ajouté. Il est en attente de validation par un modérateur.";
              _this.message_type = "alert-success"
              _this.step = "type"
              _this.init()
            } else {
              _this.message = response.data.error;
              _this.message_type = "alert-danger"
            }
          })
          .catch(function (response) {
            //handle error
          });
    }
  },
}
</script>
